import React, { Fragment, useState, useEffect } from 'react';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import MuiTable from '../../features/MuiTable';
import http from '../../services/httpService';
import { appDataStore } from '../../constants';
import YearCountyDistrictSrchForm from '../../components/super-salary/year-county-district-srch-form';

export default function SuperSalary(props) {
  const [tableData, setTableData] = useState([]);
  const [formData, setFormData] = useState({
    year: [],
    county: [],
    district_name: [],
  });

  useEffect(() => {
    console.log('useEffect ss');
    getTableData();
  }, []);

  const getTableData = async () => {
    //const response = await getRequest('SchoolsSuperSalary', '');
    const response = await http.get(appDataStore.apiConfig.SchoolSuperSalary.url);
    setTableData(response.data);
    try {
    } catch (ex) {
      if (ex.response && ex.response.status === 404) props.history.replace('/not-found');
    }
  };

  const tableColumns = [
    { title: 'Year', field: 'year' },
    { title: 'County', field: 'county' },
    { title: 'District', field: 'district_name' },
    { title: 'Salary', field: 'fte_pay' },
    { title: 'Enrollment', field: 'enrollment' },
    { title: 'Salary/enrollment', field: 'perEnrolled' },
    /*     { title: 'Fiber Qualified', field: 'currentFTTP', render: (rowData) => <YesNoIcon data={rowData} key='currentFTTP' value={rowData.currentFTTP} /> }, */
  ];

  const handleYearChange = (input) => {
    //console.log('handleYearChange', input);
    const newFormData = { ...formData };
    newFormData.year = input;
    setFormData(newFormData);
  };

  const handleCountyChange = (input) => {
    //console.log('handleYearChange', input);
    const newFormData = { ...formData };
    newFormData.county = input;
    setFormData(newFormData);
  };

  const handleDistrictChange = (input) => {
    //console.log('handleYearChange', input);
    const newFormData = { ...formData };
    newFormData.district_name = input;
    setFormData(newFormData);
  };

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          {/* <Tags data={tableData} /> */}
          <YearCountyDistrictSrchForm data={tableData} onYearChange={handleYearChange} onCountyChange={handleCountyChange} onDistrictChange={handleDistrictChange} />
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
          <MuiTable title='Superintendent Salary' data={tableData} columns={tableColumns} edit={true} />
        </Paper>
      </Grid>
    </Grid>
  );
}
